import React, { useState, useEffect, Fragment } from 'react';
import {
    Row,
    Input,
    FormGroup,
    Label,
    CustomInput,
    Button,
    ButtonGroup,
    Form,
} from 'reactstrap';
import { Colxx, Separator } from '../../../../../components/common/CustomBootstrap';
import { AxiosAPI, AxiosPublicAPI, getGroupID } from '../../../../../helpers/AxiosAPI';
import {
    gAPI_Property_List_By_Group,
    API_SABRE,
    API_PARTNER_SABRE,
} from '../../../../../constants/APIs';
import { NotificationManager } from '../../../../../components/common/react-notifications';

const domainOptions = [
    { label: "Integration 1", value: "chc-i1.synxis.com" },
    { label: "Certification 1", value: "chc-c1.synxis.com" },
    { label: "Certification 2", value: "chc-c2.synxis.com" },
    { label: "Certification 3", value: "chc-c3.synxis.com" },
    { label: "Production 1", value: "chc-p1.synxis.com" },
];
export default function SabreIntegration({ propertyId, isSuccess, setIsSuccess, clickEnd, getdata, stepStatusMap, stepCreate, userName, id }) {
    const [property, setProperty] = useState([]);
    const [open, setOpen] = useState(false);
    const [successMessage, setSuccessMessage] = useState('');
    const [msg, setMsg] = useState([]);
    const [initialProperties, setInitialProperties] = useState([]);
    const [showRatesRadios, setRatesRadios] = useState(false);
    const [isValidating, setIsValidating] = useState(false);
    const [validationStatus, setValidationStatus] = useState(null);
    const [hasChanged, setHasChanged] = useState(false);
    const isUpdated = stepStatusMap?.synxisIntegration === "UpdatedOrCreated";
    const [maskData, setMaskData] = useState({
        UserName: '',
        Password: '',
    });
    const [inputData, setInputData] = useState({
        GroupId: getGroupID(),
        Name: 'SynXis',
        Properties: [],
        SessionTimeoutInSeconds: 600,
        DefaultLanguage: 'en-US',
        UserName: '',
        Password: '',
        HotelCode: '',
        Domain: '',
        ShowRates: false,
        ShowAvailability: false,
        ShowRatesAllRoom: false,
        ShowRatesSelectedRoom: false,
        RatePlanCode: '',
        ChannelCode: '',
        ChannelId: '',
    });

    useEffect(() => {
        AxiosAPI({
            method: 'get',
            url: `${gAPI_Property_List_By_Group}/?group_id=${getGroupID()}`,
        })
            .then((res) => {
                setProperty(res.data);

                setInputData((prev) => ({
                    ...prev,
                    Properties: propertyId ? [propertyId] : [],
                }));
            })
            .catch((err) => console.error(err));
    }, [propertyId]);
    const mask = (value) => {
        let maskedValue = '';
        for (let i = 0; i < value.length - 2; i++) {
            maskedValue += '*';
        }
        return maskedValue + value.substring(value.length - 2, value.length);
    };
    const handleRateChange = (e) => {
        const checked = e.target.checked;
        setRatesRadios(checked);
        setInputData({
            ...inputData,
            ShowRates: checked,
            ShowRatesAllRoom: checked ? inputData.ShowRatesAllRoom || true : false,
            ShowRatesSelectedRoom: false,
        });
        setHasChanged(true)
    };

    const handleShowAllChange = (e) => {
        if (e.target.checked === true) {
            setInputData({
                ...inputData,
                ShowRatesAllRoom: e.target.checked,
                ShowRatesSelectedRoom: false,
            });
        } else {
            setInputData({ ...inputData, ShowRatesAllRoom: e.target.checked });
        }
    };

    const handleShowSelectedChange = (e) => {
        if (e.target.checked === true) {
            setInputData({
                ...inputData,
                ShowRatesSelectedRoom: e.target.checked,
                ShowRatesAllRoom: false,
            });
        } else {
            setInputData({ ...inputData, ShowRatesSelectedRoom: e.target.checked });
        }
    };

    const handleAvailabilityChange = (e) => {
        setInputData({ ...inputData, ShowAvailability: e.target.checked });
        setHasChanged(true)
    };

    const handleRatePlanChangeChange = (e) => {
        setInputData({ ...inputData, RatePlanCode: e.target.value });
    };

    const handleApiKeyChange = (e) => {
        setSuccessMessage('');
        e.persist();
        setMaskData({ ...maskData, UserName: mask(e.target.value) });
        setInputData({ ...inputData, UserName: e.target.value });
        //console.log(inputData)
    };
    const handlePasswordChange = (e) => {
        setSuccessMessage('');
        e.persist();
        setMaskData({ ...maskData, Password: mask(e.target.value) });
        setInputData({ ...inputData, Password: e.target.value });
        setHasChanged(true)
    };
    const handleHotelDetailsChange = (e) => {
        setSuccessMessage('');
        e.persist();
        setInputData({ ...inputData, [e.target.name]: e.target.value });
        setHasChanged(true)
    };
    const handleDomainChange = (e) => {
        setSuccessMessage('');
        const { value } = e.target;

        setInputData((prev) => ({
            ...prev,
            Domain: value,
        }));
        setHasChanged(true)
    };
    const validateProperty = async () => {
        if (!propertyId) return;

        setIsValidating(true);
        setValidationStatus(null);

        const selectedProperty = property.find(p => p.id === propertyId);

        if (!selectedProperty?.providerPropertyId) {
            NotificationManager.warning(
                'This property is not mapped with providerPropertyId.',
                'Warning',
                3000
            );
            setIsValidating(false);
            return;
        }

        try {
            const res = await AxiosPublicAPI({
                method: 'post',
                url: `${API_PARTNER_SABRE}/validate`,
                data: {
                    userName: inputData.UserName,
                    password: inputData.Password,
                    channelId: inputData.ChannelId || '10',
                    channelCode: inputData.ChannelCode || 'WSBE',
                    domain: inputData.Domain,
                    hotelCode: selectedProperty.providerPropertyId,
                },
            });

            if (res.data && res.data.length > 0) {
                setValidationStatus('success');
                NotificationManager.success(
                    'Property validated successfully.',
                    'Success',
                    3000
                );
            } else {
                setValidationStatus('failed');
                NotificationManager.error(
                    'Validation failed.',
                    'Error',
                    3000
                );
            }
        } catch (error) {
            setValidationStatus('failed');
            NotificationManager.error(
                'Validation failed.',
                'Error',
                3000
            );
        } finally {
            setIsValidating(false);
        }
    };
    const getValidatedProperties = () => {
        return inputData.Properties.filter(
            (propertyId) => validationStatus[propertyId] === 'success'
        );
    };

    const handleSave = async () => {
        if (validationStatus !== 'success') {
            NotificationManager.warning(
                'Please validate the property before creating integration.',
                'Warning',
                3000
            );
            return;
        }

        const payload = {
            ...inputData,
            ChannelCode: inputData.ChannelCode?.trim() || "WSBE",
            ChannelId: inputData.ChannelId?.trim() || "10",
            Properties: [propertyId],
        };

        try {
            const res = await AxiosAPI({
                method: 'post',
                url: API_SABRE,
                data: payload,
            });

            if (res.data?.HttpStatusCode === 400 && res.data?.Messages?.length) {
                setMsg(res.data.Messages);
                setOpen(true);
                return;
            }

            const synxisId = res?.data?.id;

            const stepPayload = {
                onboardSessionId: id,
                stepName: "synxis-integration",
                status: "UpdatedOrCreated",
                creator: userName,
                modifiedBy: "Dashboard",
                SynxisIntegration: {
                    iid: synxisId,
                    validationStatus: "success"
                }
            };

            console.log("StepCreate Payload:", stepPayload);

            await stepCreate(stepPayload);

            setIsSuccess(true);
            setHasChanged(false);

            await getdata(id);

            NotificationManager.success(
                'SynXis integration created successfully',
                '',
                3000
            );

        } catch (error) {
            console.error(error);
            NotificationManager.error(
                'Integration failed',
                '',
                3000
            );
        }
    };
    const handleNotNow = async () => {
        await stepCreate({
            onboardSessionId: id,
            stepName: "synxis-integration",
            status: "Skipped",
            creator: userName,
            modifiedBy: "Dashboard",
        });
        clickEnd()
       
    };

    return (
        <Fragment>
            <Row className="mt-2  mr-4">
                <Colxx sm={12} className="">
                    <h4>Add SynXis Channel Connect Integration</h4>
                    <Form>
                        <FormGroup>
                            <Label>User Name</Label>
                            <Input className=' input_sty' placeholder='UserName' onChange={(e) => {setInputData({ ...inputData, UserName: e.target.value } )}} />
                        </FormGroup>

                        <FormGroup className="mb-2">
                            <Label>Password</Label>
                            <Input className=' input_sty'
                                type="text"
                                name="Password"
                                onChange={handlePasswordChange}
                                placeholder="Password"
                                defaultValue={maskData.Password}
                            />
                        </FormGroup>
                        <FormGroup className="mb-2">
                            <Label>Domain</Label>
                            <Input
                                type="select"
                                name="Domain"
                                className="input_sty"
                                value={inputData.Domain}
                                onChange={handleDomainChange}
                            >
                                <option value="">Select Domain</option>
                                {domainOptions.map((option) => (
                                    <option key={option.value} value={option.value}>
                                        {option.label} ({option.value})
                                    </option>
                                ))}
                            </Input>
                        </FormGroup>
                        <FormGroup className="mb-2">
                            <Label>Channel Code (Default WSBE)</Label>
                            <Input className=' input_sty'
                                type="text"
                                name="ChannelCode"
                                onChange={handleHotelDetailsChange}
                                placeholder="Channel Code"
                                defaultValue={inputData.ChannelCode}
                            />
                        </FormGroup>
                        <FormGroup className="mb-2">
                            <Label>Channel Id (Default 10)</Label>
                            <Input className=' input_sty'
                                type="text"
                                name="ChannelId"
                                onChange={handleHotelDetailsChange}
                                placeholder="Channel Id"
                                defaultValue={inputData.ChannelId}
                            />
                        </FormGroup>
                        <FormGroup className="mb-2" style={{ display: 'none' }}>
                            <div className="">
                                <CustomInput
                                    key="ShowAvailability"
                                    type="checkbox"
                                    label="Show Availability Summary in Rooms View"
                                    name="ShowAvailability"
                                    checked={inputData.ShowAvailability}
                                    onChange={handleAvailabilityChange}
                                />
                            </div>
                        </FormGroup>
                        <FormGroup className="mb-3">
                            <div className="">
                                <CustomInput
                                    key="showRates"
                                    type="checkbox"
                                    label="Show Rates & Availability in AI Chatbot Calendar"
                                    name="showRates"
                                    checked={inputData.ShowRates}
                                    onChange={handleRateChange}
                                />
                            </div>
                        </FormGroup>
                        <Colxx sm={12} className="text-right mt-4">
                            {isUpdated && !hasChanged ? (
                                <Button color="primary" outline onClick={clickEnd}>
                                    Next
                                </Button>
                            ) : (
                                <div className='widget-wrap'>
                                    <Button
                                        color="dark"
                                        outline
                                        className="mr-2"
                                        onClick={validateProperty}
                                        disabled={isValidating}
                                    >
                                        {isValidating ? 'Validating...' : 'Validate Integration'}
                                    </Button>

                                    {validationStatus === 'success' && (
                                        <span style={{ color: 'green', marginLeft: 4 }}>✔ Valid</span>
                                    )}

                                    {validationStatus === 'failed' && (
                                        <span style={{ color: 'red', marginLeft: 4 }}>✖ Invalid</span>
                                    )}
                                    <Button className='ml-2' color="primary" outline onClick={handleSave}>
                                        Create SynXis Integration
                                    </Button>
                                    <h6
                                        style={{ display: 'flex' }}
                                        className="ml-4 not-now"
                                        onClick={handleNotNow}
                                    >
                                        Not Now <svg className='not-now' width="60" height="20" viewBox="70 15 40 20" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M60 25 H100 L90 15 M100 25 L90 35"
                                                fill="none"
                                                stroke="grey"
                                                stroke-width="2"
                                                stroke-linecap="round"
                                                stroke-linejoin="round" />
                                        </svg>

                                    </h6>
                                </div>
                            )}
                        </Colxx>
                    </Form>

                </Colxx>
            </Row>
        </Fragment>
    );
}
